import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { ButtonIcon, COLORS, Text } from '../Basics';
import LorentzService from '../../services/LorentzService';
import { useStore } from '../../store/Context';

/**
 * Barra de ações CTI — captura, transferência central, gravação.
 * Equivalente à toolbar do PhoenixCliente (captura, transferir, gravar).
 */
export const CtiActionsBar = ({ onTransferClick }) => {
  const { lorentz = {} } = useStore();
  const [recording, setRecording] = useState(false);
  const [capturing, setCapturing] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const onRec = ev => {
      setRecording(!!(ev.detail || ev.data)?.active);
    };
    document.addEventListener('lorentz:recording:changed', onRec);
    setRecording(LorentzService.isRecording());
    return () =>
      document.removeEventListener('lorentz:recording:changed', onRec);
  }, []);

  if (!lorentz.enabled || !lorentz.authenticated) return null;

  const run = async (fn, label) => {
    setError('');
    try {
      await fn();
    } catch (err) {
      setError(`${label}: ${err?.message || 'erro'}`);
    }
  };

  const handleCapture = async () => {
    setCapturing(true);
    try {
      await run(() => LorentzService.captureCall(), 'Captura');
    } finally {
      setCapturing(false);
    }
  };

  const handleRecording = () =>
    run(() => LorentzService.toggleRecording(), 'Gravação');

  return (
    <View style={{ marginBottom: 8 }}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
          paddingVertical: 6,
          backgroundColor: COLORS.backColor,
          borderRadius: 8
        }}
      >
        <View style={{ alignItems: 'center', marginHorizontal: 8 }}>
          <ButtonIcon
            icon="phoneForwarded"
            color="primary"
            onClick={onTransferClick}
            testID="ctiTransferBtn"
          />
          <Text style={{ fontSize: 10, marginTop: 2 }}>Transferir</Text>
        </View>

        <View style={{ alignItems: 'center', marginHorizontal: 8 }}>
          <ButtonIcon
            icon="phone"
            color={capturing ? 'warning' : 'primary'}
            onClick={handleCapture}
            testID="ctiCaptureBtn"
          />
          <Text style={{ fontSize: 10, marginTop: 2 }}>Capturar (*)</Text>
        </View>

        {lorentz.recordingEnabled !== false && (
          <View style={{ alignItems: 'center', marginHorizontal: 8 }}>
            <ButtonIcon
              icon={recording ? 'pause' : 'micOff'}
              color={recording ? 'danger' : 'textSecondary'}
              onClick={handleRecording}
              testID="ctiRecordingBtn"
            />
            <Text style={{ fontSize: 10, marginTop: 2 }}>
              {recording ? 'Gravando' : 'Gravar'}
            </Text>
          </View>
        )}
      </View>

      {recording && (
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 4
          }}
        >
          <View
            style={{
              width: 8,
              height: 8,
              borderRadius: 4,
              backgroundColor: COLORS.danger,
              marginRight: 6
            }}
          />
          <Text style={{ fontSize: 11, color: COLORS.danger }}>
            Gravação CTI ativa
          </Text>
        </View>
      )}

      {error ? (
        <Text
          style={{
            fontSize: 11,
            color: COLORS.danger,
            textAlign: 'center',
            marginTop: 4
          }}
        >
          {error}
        </Text>
      ) : null}
    </View>
  );
};

export default CtiActionsBar;
